import { createServiceClient } from "shared/welda/services/axiosClient";

const api = createServiceClient("/cookie");

const getCookie = async (dossierNr) => await api.get(`/${dossierNr}`);

const checkCookie = async () => await api.get(`/check`);

const cookieService = {
  getCookie,
  checkCookie,
};

export default cookieService;
